









































































































































import Vue from 'vue';
import IndicatorComponent from '@/components/InfoIndicator.vue';
import {
  requestMembership,
  requestEditInfo,
  requestCompanyUpdate
} from '@/constants/sidebarData';
import tableComponent from '@/components/TheTable.vue';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import Component from 'vue-class-component';
import { Base } from '@/base';

@Component({
  name: 'HomePage',
  components: {
    IndicatorComponent,
    tableComponent,
    PulseLoader
  }
})
export default class HomePage extends Base {
  companyUpdateTable = {
    titleText: 'COMPANY UPDATES',
    titleBg: 'pink-title',
    sorted: 'id',
    columns: [
      { field: 'id', title: '#' },
      { field: 'text', title: 'TEXT' },
      { field: 'name', title: 'FROM' },
      { field: 'date', title: 'DATE' }
      ],
    rows: []
  };
  infoTotalSupplyObj = {
    title: 'TOTAL SUPPLY',
    value: 'No', // for example: 100,000,000 KORP
    color: 'gradient-1'
  };
  infoShareholdersObj: any = {
    title: 'SHAREHOLDERS',
    value: 'No', // for example: 23
    color: 'gradient-2'
  };
  infoFinancialsObj = {
    title: 'FINANCIALS AVAILABLE',
    value: 'No', // for example: Yes
    color: 'gradient-3'
  };
  infoOrdersObj = {
    title: 'OPEN ORDERS',
    value: 'No', // for example: No
    color: 'gradient-4'
  };
  titleText = 'COMPANY UPDATES';
  titleBg = 'pink-title';

  constructor() {
    super();
  }


  get isCompanyInfoPending() {
    return this.getPendings.companyInfo.update;
  }
  get isrequestMemberPending() {
    return this.getPendings.member.update;
  }
  get isCompanyUpdatePending() {
    return this.getPendings.companyUpdate.new;
  }
  get _isTreasuryWallet() {
    if (this.getWallet && this.getWallet === this.getCompanyInfo.wallet) {
      this.$router.push('/shareholder');
    }
    return true;
  }
  get isAgent() {
    return this.isReader;
  }
  get companyUpdateData() {
    let rows: any[] = [];
    for (let id in this.getCompanyUpdates) {
      let row: any = {};
      let update = this.getCompanyUpdates[id];
      let addr = update.address;
      row.id = update.id;
      row.text = update.title;

      row.name = this.getMember(addr) ? this.getMember(addr).name : '';
      row.date = update.date;
      rows.push(row);
    }
    Vue.set(this.companyUpdateTable, 'rows', rows);
    return this.companyUpdateTable;
  }
  get textButton() {
    if (!this.getInitStatusToken) return 'System Initialization';
    if (!this.getInitStatusFirstOwner) return 'First Owner Initialization';
    if (!this.getInitStatusOwners) return 'Owners Initialization';
    return '';
  }

  requestJoinCompany() {
    this.setSideBarForm(requestMembership());
    this.openClose();
  }

  requestCompanyUpdate() {
    this.setSideBarForm(requestCompanyUpdate());
    this.openClose();
  }

  infoTotalSupply() {
    if (this.getTokenTotalSupply && this.getTokenSymbol) {
      this.infoTotalSupplyObj.value = this.getTokenTotalSupply + ' ' + this.getTokenSymbol;
    }
    return this.infoTotalSupplyObj;
  }

  infoShareholders() {
    if (this.getMemberCounter) {
      this.infoShareholdersObj.value = this.getMemberCounter;
    }
    return this.infoShareholdersObj;
  }

  infoFinancials() {
    if (this.getFinStatementCounter) {
      this.infoFinancialsObj.value = 'Yes';
    }
    return this.infoFinancialsObj;
  }

  infoOrders() {
    if (this.getActiveOrderCounter) {
      this.infoOrdersObj.value = 'Yes';
    }
    return this.infoOrdersObj;
  }

  requestEditInfo(data) {
    this.setSideBarForm(requestEditInfo(data));
    this.openClose();
  }
}
